<script>
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import ButtonText from "@/components/Global/ButtonText.vue";
import CheckBox from "@/components/Global/CheckBox.vue";
import axiosInstance from "@/helpers/axios";
import { mapMutations } from "vuex";
import eventBus from "@/helpers/eventBus";

export default {
  name: "BillingProductsAgreement",
  components: { CheckBox, ButtonText, ButtonPrimary },
  emits: ["closeModal", "continue"],
  data() {
    return {
      isAgreed: false,
    };
  },
  methods: {
    ...mapMutations({
      setBillingProductIsAgreed: "order/setBillingProductIsAgreed",
    }),
    closeModal() {
      this.$emit("closeModal");
    },
    async approve() {
      if (this.isAgreed) {
        try {
          eventBus.emit("billingAgreed");
          await axiosInstance.post(
            `/orders/approve_billing_products/${this.orderId}`,
            {
              items: this.billingProducts.map((item) => item.itemID),
            }
          );
          this.setBillingProductIsAgreed(true);
        } catch (e) {
          console.error(e);
          this.closeModal();
          return void 0;
        }
      }
      this.$emit("continue");
      this.closeModal();
    },
  },
  props: {
    billingProducts: {
      type: Array,
      default: [],
    },
    orderId: {
      default: null,
    },
  },
  mounted() {},
};
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center z-[80] bg-black bg-opacity-50"
  >
    <div class="bg-white rounded shadow-lg w-[660px] h-fit flex flex-col">
      <h2
        class="text-2xl text-center text-primary-300 flex items-center justify-center gap-2 mt-[55px] mb-[55px] font-bold"
      >
        רגע לפני שאתם מתחילים
      </h2>
      <h3
        class="self-center text-grays-800 text-base mb-[55px] w-[500px] text-center"
      >
        תאשרו לנו שאתם יודעים שבכל הזמנה תחוייבו:
        <div>
          ב-{{
            billingProducts
              .map((item) => item.price + " ₪ עבור " + item.product.full_name)
              .join(" + ")
          }}
        </div>
      </h3>

      <div
        class="border-t border-grays-300 flex flex-row-reverse px-8 mb-4 gap-2 items-center"
      >
        <button-primary class="mt-6 self-end" @click="approve">
          מאשרים
        </button-primary>
        <div class="flex flex-row gap-1 mt-5">
          לא צריך להזכיר לנו עוד פעם
          <check-box v-model="isAgreed"></check-box>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>